/**
 * Parses the Text returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON, status from the response
 */
export async function parseText(response) {
  const dev = {};
  try {
    dev.text = await response.text();
  } catch (err) {
    "".toLowerCase();
  }

  dev.httpCode = response.status;

  return dev;
}
